module.exports = __webpack_public_path__ + "img/background-image.ae8db182.png";